import React from "react";
import { nl } from "./nl.jsx";

// Sekcja "Czemu my". Nagłówek to pojedyncze textarea (\n → <br/>), bez pól "linia 1/2".
const noop = () => {};

export function HomeReason({
  eyebrow = "",
  title = "",
  statNum = "",
  statH = "",
  statCaption = "",
  cta = "",
  differs = [],
  navigate,
  reveal = true,
}) {
  const nav = navigate || noop;
  const go = (r) => () => nav(r);
  const rv = reveal ? " rv" : "";
  return (
    <section className="sec container">
      <div className="czemu-my-grid">
        <div className={"czemu-my-left" + rv}>
          <span className="section-eyebrow">{eyebrow}</span>
          <h2 className="h2 czemu-my-h2">{nl(title)}</h2>
          <div className="czemu-my-stat">
            <span className="stat-num">{statNum}</span>
            <h3 className="stat-h">{statH}</h3>
            <span className="czemu-my-stat-caption">{statCaption}</span>
          </div>
        </div>
        <div className="differ-tiles">
          {differs.map((d, i) => (
            <div key={d.k || i} className={"differ-card" + rv}>
              <span className="differ-num">[{d.k}]</span>
              <h3 className="differ-title">{d.title}</h3>
              <p className="differ-body">{d.body}</p>
            </div>
          ))}
        </div>
      </div>
      <div className={"czemu-my-cta" + rv}>
        <button className="lc-btn lc-btn-ghost lc-btn-lg" onClick={go("/o-nas")}>
          {cta} <span className="lc-btn-arr">↗</span>
        </button>
      </div>
    </section>
  );
}
